var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dialogos-app',{attrs:{"dialogos":_vm.dialogos}}),_c('div',{staticClass:"text-xs-center"},[_c('svg-buttons',{on:{"finished":function($event){return _vm.$store.commit('nextShow', true)}}})],1),_c('audio-player',{ref:"audioPlayer",attrs:{"autoplay":true,"audios":[
    'Modulo 3/AUDIO 08'
  ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }